module.exports = __webpack_public_path__ + "static/media/ac-chevron-down.cde5a84b.svg";